import { SchemaType } from '../types/schema';

export interface SchemaDefaults {
  schemaUrl: string;
  cacheKey: string;
  templateCollection: string;
  requestCollection: string;
  bulkRequestCollection: string;
  displayName: string;
}

export const SCHEMA_CONFIG: Record<SchemaType, SchemaDefaults> = {
  geneva: {
    schemaUrl: 'https://storage.googleapis.com/kfh-capital-crm.appspot.com/geneva_schema.json',
    cacheKey: 'geneva_schema_cache2',
    templateCollection: 'templates',
    requestCollection: 'geneva_requests',
    bulkRequestCollection: 'geneva_bulk_requests',
    displayName: 'Geneva',
  },
  gwi: {
    schemaUrl: 'https://storage.googleapis.com/kfh-capital-crm.appspot.com/gwi_schema.json',
    cacheKey: 'gwi_schema_cache1',
    templateCollection: 'templates',
    requestCollection: 'geneva_requests',
    bulkRequestCollection: 'geneva_bulk_requests',
    displayName: 'World Investor',
  },
};

export const DEFAULT_SCHEMA_TYPE: SchemaType = 'geneva';
